// extracted by mini-css-extract-plugin
export default {"numberInput":"number-input_numberInput__zGw2T","label":"number-input_label__C2Qd7","input":"number-input_input__qxtxH"};